import { GenericResource, IHttpAgent } from '@sparelabs/http-client-utils'
import { ICaseTagPostBody, ICaseTagResponse, IListCaseTagQueryParams } from '../types/CaseTagTypes'
import { Resources } from './ResourcesType'

export class CaseTagResource extends GenericResource<
  ICaseTagResponse,
  IListCaseTagQueryParams,
  never,
  ICaseTagPostBody
> {
  constructor(agent: IHttpAgent) {
    super(Resources.CaseTags, agent)
  }

  // Override list to handle path parameter
  public list = async (params: IListCaseTagQueryParams & { caseId: string }, fetchAllPages: boolean = false) => {
    const { caseId, ...queryParams } = params
    const resourcePath = this.resource.replace(':id', caseId)

    if (fetchAllPages) {
      const data = await this.allPageFetcher.fetch<ICaseTagResponse, IListCaseTagQueryParams>(resourcePath, queryParams)
      return { data, skip: 0, total: data.length, limit: data.length }
    }

    const { data } = await this.agent.get<{ data: ICaseTagResponse[]; total: number; skip: number; limit: number }>(
      resourcePath,
      { params: queryParams },
    )
    return data
  }

  // Override post to handle path parameter
  public post = async (body: ICaseTagPostBody, params: { caseId: string }) => {
    const resourcePath = this.resource.replace(':id', params.caseId)
    const res = await this.agent.post<ICaseTagResponse>(resourcePath, body)
    return res.data
  }

  // Override delete to handle path parameters
  public delete = async (id: string, params: { caseId: string }) => {
    const resourcePath = this.resource.replace(':id', params.caseId)
    const res = await this.agent.delete(`${resourcePath}/${id}`)
    return res.data
  }
}
